import { render, staticRenderFns } from "./BaseShare.vue?vue&type=template&id=49563a64&scoped=true&"
import script from "./BaseShare.vue?vue&type=script&lang=js&"
export * from "./BaseShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseShare.vue?vue&type=style&index=0&id=49563a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49563a64",
  null
  
)

export default component.exports